import { createReducer, on } from '@ngrx/store';
import { loadWordpressFailure, loadWordpressSuccess } from './wordpress.actions';
import { WpCategory } from '../../types/wordpress/category.type';
import { StoreState } from '../index';
import { WpCommonData } from '../../types/wordpress/common-data.type';
import { WpDocumentary } from '../../types/wordpress/documentary.type';

export const featureKey = 'wordpress';

export interface State extends StoreState {
  categories?: WpCategory[];
  documentaries?: WpDocumentary[];
  commonData?: WpCommonData;
}

export const initialState: State = {};

export const reducer = createReducer(
  initialState,
  on(loadWordpressSuccess, (state, {data}) => ({
    ...state,
    categories: data.categories,
    commonData: data.commonData,
    documentaries: data.documentaries,
    status: {...initialState.status, ready: true},
  })),
  on(loadWordpressFailure, (state, {error}) => ({...state, status: {loading: false, error, ready: true}})),
);

